<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs" />
<!--     <b-row v-if="event">
      <b-col>
        <b-alert variant="info" show>{{status}}</b-alert>
      </b-col>
    </b-row> -->
    <b-alert variant="danger" :show="hasError">{{errorMessage}}</b-alert>
    <b-row v-if="event">
      <b-col>
        <b-form inline class="mb-3">
          <label for="team" class="mr-3">My Current team: </label>
          <b-form-select id="team" :options="teams" v-model="teamId">
          </b-form-select>
          <b-dropdown right text="Download Case Data" class="ml-auto mb-3" v-if="event">
            <b-dropdown-item-button v-on:click="download('basic', 'docx')">Download as Word Document</b-dropdown-item-button>
          </b-dropdown>
        </b-form>
      </b-col>
    </b-row>
    <b-row v-if="event">
      <b-col>
        <h5 class="text-center mb-3" show :style="{color: boldTintColor}">{{event.status_banner_text}}</h5>
      </b-col>
    </b-row>
    <b-row v-if="event">
      <b-col md>
        <data-section v-for="(section, index) in dataSections" :section="section" :boldTintColor="boldTintColor" :key="index"></data-section>
      </b-col>
      <b-col md v-if="historyDataSections.length > 0">
        <data-section v-for="(section, index) in historyDataSections" :section="section":boldTintColor="boldTintColor" :key="index" :timeline="true"></data-section>
      </b-col>
    </b-row>
    <b-row v-if="formSections.length > 0 && !saving">
      <b-col lg="6">
        <data-section v-for="(section, index) in formSections" :section="section" :boldTintColor="boldTintColor" :key="index" ref="forms" v-on:submit="submitForms"></data-section>
        <p class="mb-3">
          <b-button variant="primary" class="ml-auto" v-on:click="submitForms">{{event.submit_button_text}}</b-button>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import API from '@/lib/api'
import DataSection from '@/components/DataSection'
import _ from 'lodash'

export default {
  name: 'Events',
  components: {
    'data-section': DataSection
  },
  props: ['id'],
  data () {
    var team = this.$route.query.team_id != null
            ? this.$store.getters.teams.find((team) => { return team.id === parseInt(this.$route.query.team_id) })
            : null
    const context = this.$route.query.context === 'inbox' ? 'Inbox' : 'All Events'
    var returnTo = this.$route.query.return_to
    if (returnTo == null || returnTo === '') {
      returnTo = '/events'
    }

    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: context, to: returnTo}, {text: 'Event', to: this.$route.fullPath, active: true}],
      lightTintColor: 'transparent',
      boldTintColor: 'black',
      returnTo: this.$route.query.return_to,
      teamId: team != null ? team.id : null,
      saving: false,
      hasError: false,
      errorMessage: null,
      event: null
    }
  },
  watch: {
    event () {
      if (this.event) {
        // this.lightTintColor = this.event.light_tint_color
        this.boldTintColor = this.event.bold_tint_color
      } else {
        // this.lightTintColor = 'transparent'
        this.boldTintColor = 'black'
      }
    },
    lightTintColor () {
      if (this.lightTintColor === 'transparent') {
        this.$parent.bgColor = this.$parent.defaultBgColor
      } else {
        this.$parent.bgColor = this.lightTintColor
      }
    },
    teamId () {
      this.$router.replace({path: `/events/${this.id}`, query: {team_id: this.teamId, return_to: this.returnTo}})
    },
    '$route' (to, from) {
      var team = this.$route.query.team_id != null
              ? this.$store.getters.teams.find((team) => { return team.id === parseInt(this.$route.query.team_id) })
              : null
      this.teamId = team != null ? team.id : null
      this.fetchData()
    }
  },
  computed: {
    dataSections () {
      if (this.event) {
        return this.event.data_sections.filter((section) => { return section.section_type !== 'event_history' && section.section_type !== 'form' })
      } else {
        return []
      }
    },
    historyDataSections () {
      if (this.event) {
        return this.event.data_sections.filter((section) => { return section.section_type === 'event_history' })
      } else {
        return null
      }
    },
    formSections () {
      if (this.event) {
        return this.event.data_sections.filter((section) => { return section.section_type === 'form' })
      } else {
        return []
      }
    },
    teams () {
      if (this.event) {
        var teamIds = this.event.teams.map((team) => { return team.id })
        return _.filter(this.$store.getters.teams, (team) => teamIds.indexOf(team.id) !== -1).map((team) => { return {text: team.name, value: team.id} })
      } else {
        return []
      }
    },
    team () {
      if (this.teamId != null) {
        return this.$store.getters.teams.find((team) => { return team.id === this.teamId })
      } else {
        return null
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      var params = {}
      if (this.teamId != null) {
        params['team_id'] = this.teamId
        this.$store.commit('selectCurrentTeam', this.team)
      }
      this.hasError = false
      API.get(`events/${this.id}`, params, this.$store.getters.authHeaders)
        .then((response) => {
          this.event = response.data
          if (this.teamId === null) {
            const team = this.$store.state.user.teams.find((userTeam) => this.event.teams.find((eventTeam) => eventTeam.id === userTeam.id) != null)
            this.teamId = team.id
          } else {
            this.markAsRead()
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.event = null
            this.errorMessage = 'Sorry, you do not have permission to view that event.'
            this.hasError = true
          }
        })
    },
    markAsRead () {
      if (this.teamId != null) {
        API.post(`events/${this.id}/read`, { team_id: this.teamId }, this.$store.getters.authHeaders)
          .then((response) => {
            API.get('account', {}, this.$store.getters.authHeaders).then((response) => {
              if (response.data != null) {
                this.$store.commit('updateUser', response.data)
              }
            })
          })
      }
    },
    terminology (term, fallback) {
      const terms = this.event.event_type.text_terms
      if (terms != null && terms[term] != null) {
        return terms[term]
      } else {
        return fallback
      }
    },
    formatDate (date) {
      return moment(date).format('L')
    },
    download (templateName, format) {
      API.post(`/events/${this.id}/export/${templateName}.${format}`, {}, this.$store.getters.authHeaders)
        .then((response) => {
          document.location = response.data.url
        })
    },
    submitForms () {
      this.hasError = false

      var isValid = true
      this.$refs.forms.forEach((form) => { isValid = form.validate() && isValid })

      if (isValid) {
        var values = []
        this.$refs.forms.forEach((form) => { values = _.concat(values, form.values()) })
        const params = {
          team_id: this.teamId,
          data_entry_values: values
        }
        this.saving = true
        API.post(this.event.update_url, params, this.$store.getters.authHeaders).then((result) => {
          API.get('account', {}, this.$store.getters.authHeaders).then((response) => {
            if (response.data != null) {
              this.$store.commit('updateUser', response.data)
            }
            this.saving = false
            this.$router.push(this.returnTo)
          })
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errorMessage = error.response.data.message
            this.hasError = true
          }
          this.saving = false
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Event.vue